import resultActions from '../actions/ResultActions';

const defaultState = { metaData: { isLoaded: false }, questions: {} };

export default function (state = defaultState, action) {
    switch (action.type) {
    case resultActions.types.RESULT_SET_STATE:
        return action.newState;

    default:
        return state;
    }
}
